<template>
  <div class="dictindex">
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>判定脚本列表</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/script/create')"
          >创建脚本</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 筛选 -->
      <el-row>
        <el-col :span="9">
          <el-input
            placeholder="请输入脚本名称"
            v-model="scriptName"
            clearable
            class="input-with-select"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="dictSearch"
            ></el-button>
          </el-input>
        </el-col>
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <TzTable :tableData="toolList" :columns="columns" />
      <!-- 表格 -->

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->

    <!-- 编辑弹框 -->
    <Edit
      :state="editState"
      @close="editState = false"
      :row="editUnit"
      @confirm="changeTool"
    />
    <!-- 编辑弹框 end -->
  </div>
</template>

<script>
import { scriptList, deleteScript, updateScript } from '@/api/scriptis'
import TzTable from '@/components/tz-table/Index.vue'
import Edit from './components/Edit'
export default {
  components: {
    TzTable,
    Edit
  },
  data() {
    return {
      page: 1, //当前页
      size: '10',
      total: 100,
      scriptName: '',
      editState: false,
      editUnit: {},
      toolList: [],
      columns: [
        {
          field: 'scriptName',
          title: '脚本名称'
        },
        {
          field: 'updateDate',
          title: '更新时间'
        },
        {
          title: '操作',
          width: '160',
          type: 'btn',
          payload: [
            {
              name: '编辑',
              type: 'primary',
              click: (row) => {
                console.log('编辑', row)
                this.editUnit = JSON.parse(JSON.stringify(row))
                // 显示弹框
                this.editState = true
              }
            },
            {
              name: '删除',
              type: 'danger',
              click: (row) => {
                console.log('删除', row)
                this.deleteFn(row)
              }
            }
          ]
        }
      ]
    }
  },
  methods: {
    handleSizeChange(val) {
      this.size = val
      this.getScriptList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getScriptList()
    },
    // 列表
    getScriptList() {
      let params = {
        scriptName: this.scriptName,
        pageSize: this.size,
        pageNum: this.page
      }
      scriptList(params).then((res) => {
        if (res.code == 200) {
          let toolArr = res.data.records
          this.total = res.data.total
          this.toolList = toolArr.map((item) => {
            return {
              id: item.id,
              updateDate: item.updateDate,
              scriptName: item.scriptName,
              scriptBody: item.scriptBody,
              inputExample: item.inputExample
            }
          })
        }
      })
    },

    // 编辑
    changeTool(infos) {
      console.log(infos)
      this.$loading({
        text: '脚本更新中'
      })
      let updateparams = {
        ...infos
      }
      updateScript(updateparams).then((res) => {
        console.log(res.data, '更新')
        this.$loading().close()
        if (res.code == 200) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.getScriptList()
        } else {
          this.$message({
            type: 'error',
            message: '更新失败!'
          })
        }
        this.editState = false
      })
    },
    // 删除
    deleteFn(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let delparams = {
            id: row.id
          }
          deleteScript(delparams).then((res) => {
            console.log(res, '删除')
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getScriptList()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 模糊查询
    dictSearch() {
      this.page = 1
      this.getScriptList()
    }
  },
  mounted() {
    this.getScriptList()
  }
}
</script>

<style></style>
